import { COUNTRY_CODE } from 'utils';
import logger from 'logger';
import locationApiClient from '@backend/src/services/locationApi';
import { paths } from '@backend/src/services/locationApi/schema';
import { Lead } from '@backend/src/frontend-mongo-interfaces/mongoose.gen';

export type LocationApiLocation =
  paths['/locationById/{locationId}']['get']['responses']['200']['content']['application/json'];

export type CloseLocations = {
  distance: number;
  location: LocationApiLocation;
}[];

export const getCloseLocations = async (
  address: Pick<Lead['fromAddress'], 'lat' | 'lon'>,
): Promise<CloseLocations> => {
  const { lat, lon } = address;

  const { data: results } = await locationApiClient.GET(
    '/locationsByCoordinates',
    {
      params: {
        query: { lat, lon, distance: '250' },
      },
    },
  );

  const locations = (results || []).filter(
    (result) =>
      result.location?.address?.country?.toLowerCase() === COUNTRY_CODE,
  );

  logger.info('getCloseLocations locations', {
    locations,
  });

  logger.info('getCloseLocations locations', { locations });

  return (locations?.slice(0, 3) || []) as CloseLocations;
};
